import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

interface ProtectedRouteProps {
    children: JSX.Element;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { accounts } = useMsal();
    const location = useLocation();

    // If no accounts, user is not authenticated - redirect to login with intended destination.
    if (!accounts || accounts.length === 0) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // User is authenticated
    return children;
};

export { };
